module.exports = require("./pt-TL.d.ts");